module.exports = __webpack_public_path__ + "static/media/48.cd08b2c4.svg";